















import Vue from 'vue'
import Authenticated from './helpers/Authenticated.vue'
import AdminOnly from './helpers/AdminOnly.vue'
import AdminMenu from '@/components/admin/AdminMenu.vue'
import NewRestaurant from '@/components/admin/NewRestaurant.vue'
import RestaurantList from '@/components/admin/RestaurantList.vue'
import AllUsers from '@/components/admin/AllUsers.vue'

export default Vue.extend({
  name: 'AdminScreen',
  components: { Authenticated, AdminOnly, NewRestaurant, RestaurantList, AllUsers, AdminMenu },
})
